var map = {
	"./1.jpg": "8554",
	"./2.jpg": "405a",
	"./3.jpg": "11d9",
	"./4.jpg": "bafb",
	"./images/bg.jpg": "3625",
	"./images/hardshell_dorsal_labelled.jpg": "5a1b",
	"./images/hardshell_lateral_labelled.jpg": "c354",
	"./images/hardshell_ventral_labelled.jpg": "fd37",
	"./images/limb_types_labelled.jpg": "dc2d",
	"./images/noimage.jpg": "750c",
	"./images/softshell_dorsal_labelled.jpg": "ea63",
	"./images/softshell_ventral_labelled.jpg": "f9bd",
	"./india.jpg": "d29d",
	"./logos/FINAL LOGO KURMA (1).jpg": "7a6b",
	"./logos/TSA .jpg": "a075",
	"./logos/contact.jpg": "0852",
	"./logos/contact1.jpg": "c73f",
	"./logos/contact3.jpg": "ad57",
	"./logos/resource-img1.jpg": "09ed",
	"./logos/resource-img2.jpg": "faf5",
	"./s1.jpg": "b5a2",
	"./s2.jpg": "051f",
	"./s3.jpg": "6a55",
	"./turtle.jpg": "bf68"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";